import styled from 'styled-components'

import { FlexCentered, FullWidthHeight } from 'components/common/genericStyles'

export const Wrapper = styled.div`
    cursor: pointer;
    ${FullWidthHeight}
    ${FlexCentered}
`
